import axiosInstance from './axiosInstance'
import { ApiResponse, Job, PagedResponse, ReferralFeePreset, User } from '../types'

export const adminApi = {
  // Jobs
  getJobs: (params: { status?: string; page?: number; size?: number }) => {
    const q = new URLSearchParams()
    if (params.status) q.set('status', params.status)
    q.set('page', String(params.page ?? 0))
    q.set('size', String(params.size ?? 10))
    return axiosInstance.get<ApiResponse<PagedResponse<Job>>>(`/admin/jobs?${q}`)
  },
  approveJob: (id: number) =>
    axiosInstance.patch<ApiResponse<Job>>(`/admin/jobs/${id}/approve`),
  rejectJob: (id: number, reason: string) =>
    axiosInstance.patch<ApiResponse<Job>>(`/admin/jobs/${id}/reject`, { reason }),

  // Users
  getUsers: (params: { search?: string; page?: number; size?: number }) => {
    const q = new URLSearchParams()
    if (params.search) q.set('search', params.search)
    q.set('page', String(params.page ?? 0))
    q.set('size', String(params.size ?? 10))
    return axiosInstance.get<ApiResponse<PagedResponse<User>>>(`/admin/users?${q}`)
  },
  deactivateUser: (id: number) =>
    axiosInstance.patch<ApiResponse<void>>(`/admin/users/${id}/deactivate`),
  activateUser: (id: number) =>
    axiosInstance.patch<ApiResponse<void>>(`/admin/users/${id}/activate`),

  // Settings
  getSettings: () =>
    axiosInstance.get<ApiResponse<Array<{ settingKey: string; settingValue: string }>>>('/admin/settings'),
  updateSetting: (key: string, value: string) =>
    axiosInstance.put<ApiResponse<unknown>>(`/admin/settings/${key}`, { value }),

  // Fee Presets
  getFeePresets: () =>
    axiosInstance.get<ApiResponse<ReferralFeePreset[]>>('/admin/fee-presets'),
  createFeePreset: (data: { label: string; amountPaise: number; sortOrder?: number }) =>
    axiosInstance.post<ApiResponse<ReferralFeePreset>>('/admin/fee-presets', data),
  toggleFeePreset: (id: number) =>
    axiosInstance.patch<ApiResponse<ReferralFeePreset>>(`/admin/fee-presets/${id}/toggle`),
  deleteFeePreset: (id: number) =>
    axiosInstance.delete<ApiResponse<void>>(`/admin/fee-presets/${id}`),

  // Broadcast
  broadcastNotification: (data: { title: string; body: string }) =>
    axiosInstance.post<ApiResponse<void>>('/admin/notifications/broadcast', data),
}
